import { css } from 'linaria';
import { styled } from 'linaria/react';

export const Container = styled.div<{ marginVertical?: string }>`
  position: relative;
  display: block;
  max-width: var(--layout-max-width);
  margin-block: ${({ marginVertical }) => marginVertical ?? 0}px;
`;

export const sectionDivider = css`
  @media (--from-tablet) {
    margin-block-start: 0;

    &::before {
      content: '';
      display: block;
      width: 100%;
      margin-block: var(--space-500);
      border-top: 1px solid var(--control-minor);
    }
  }
`;
